import { Link } from 'react-router-dom'

import { PageHeader, Panel } from '../components/ui'
import { t } from '../i18n'

export function NotFound() {
  return (
    <div className="content__inner">
      <PageHeader title={t('errors.notFoundTitle')} />
      <Panel className="placeholder">
        <p className="placeholder__lead">{t('errors.notFoundBody')}</p>
        <Link to="/">{t('errors.goHome')}</Link>
      </Panel>
    </div>
  )
}
